<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5" id="grad1">
                <!-- breadcrumb and title row starts -->
                <div class="row">
                    <div class="col-sm-12">
                        <vs-breadcrumb align="left" :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/program-officer/todoList'
                  },

                  {
                    title: `Event Wizard`,

                  },
                  {
                    title: ` ${updateTraining.title} ${formatDateRange(updateTraining.startdate, updateTraining.enddate)}`,
                    active: true,
                    class: 'font-bold'
                  }
                ]"></vs-breadcrumb>
                    </div>
                    <div class="col-sm-12">
                        <div class="heading mt-3">
                            <h3 class="text-secondary">Event Wizard</h3>
                        </div>
                    </div>
                </div>
                <!-- breadcrumb and title row Ends -->
                <div class="row justify-content-center mt-0">
                    <div class="col-11 text-center p-0 mt-3 mb-2">
                        <div class="card px-0 pb-0 mt-3 mb-3">
                            <div class="row">
                                <div class="col-md-12 mx-0">
                                    <form id="msform" @submit.prevent="TrainingForm">
                                        <!-- progressbar -->
                                        <ul id="progressbar">
                                            <li title="Warning! You are not authorized to access." id="NewTraining">
                                                <strong>Event Assignment</strong>
                                            </li>
                                            <li title="Warning! You are not authorized to access." id="PoAssignment">
                                                <strong>P.O Assignment</strong>
                                            </li>
                                            <li class="active" id="TrainingInformation">
                                                <strong>Event Information</strong>
                                            </li>
                                            <li @click="trainerRegistration()" id="TrainerRegistration">
                                                <strong>Facilitators' Registration</strong>
                                            </li>
                                            <li @click="trainingAgenda()" id="TrainingAgenda">
                                                <strong>Event Agenda</strong>
                                            </li>
                                            <li @click="trainingMaterial()" id="Trainingmaterial">
                                                <strong>Upload Material</strong>
                                            </li>
                                            <li @click="trainingAssessment()" id="TrainingAssessments">
                                                <strong>Assessments</strong>
                                            </li>

                                            <li @click="traineeReg()" id="TraineeRegistration">
                                                <strong>Participants' Registration</strong>
                                            </li>
                                            <li @click="assessmentReviewFunction()" id="AssessmentReview">
                                                <strong>Review</strong>
                                            </li>
                                            <li @click="trainingCompletion()" id="Completion">
                                                <strong>Completion</strong>
                                            </li>
                                        </ul>
                                        <!-- fieldsets -->
                                        <fieldset style="text-align: left;padding: 30px;">
                                            <h5>Event Information</h5>
                                            <!-- row 1 starts  -->
                                            <div class="row mt-5">
                                                <!--  col-md-6   -->
                                                <div class="col-md-6">
                                                    <div class="">
                                                        <label style="font-weight:700;">Event Title</label>
                                                        <input style="opacity: 1 !important;background-color: #d3d3d3;" type="text" class="form-control form-control-sm" placeholder="Terrorism Investigation Course" disabled id="training_title" :value="updateTraining.title" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="">
                                                        <label style="font-weight:700;">Sub Program</label>
                                                        <input style="opacity: 1 !important;background-color: #d3d3d3;" type="text" class="form-control form-control-sm" placeholder="Terrorism Investigation Course" disabled id="sub_program" :value="updateTraining.subprogram.title" />
                                                    </div>
                                                </div>
                                                <!--  col-md-6   -->
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-md-6">
                                                    <div class="">
                                                        <label style="font-weight:700;">Project</label>
                                                        <select style="opacity: 1 !important;background-color: #d3d3d3;" class="form-control form-control-sm" id="exampleFormControlSelect1 project" disabled>
                                                            <option :value="updateTraining.project.id" selected>
                                                                {{updateTraining.project.title}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="">
                                                        <label style="font-weight:700;">Donor Name</label>
                                                        <selectize id="select-state doner_name" disabled v-model="donerSelected" :settings="donersettings">
                                                            <option v-for="(item,index) in selectedDoner" :key="index" :value="item.id" disabled>
                                                                {{item.title}}
                                                            </option>
                                                        </selectize>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- row 2 starts  -->
                                            <div class="row mt-2">
                                                <!--  col-md-6   -->
                                                <div class="col-md-6">
                                                    <div class="">
                                                        <label style="font-weight:700;">Department
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                                        <selectize id="select-state department" v-model="department" :settings="departmentsettings" :disabled="isDateValid">
                                                            <option v-for="(item,index) in departmentArr" :key="index" :value="item.id">
                                                                {{item.title}}
                                                            </option>
                                                        </selectize>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="">
                                                        <label style="font-weight:700;">Type
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                                        <selectize v-model="type_training" :disabled="isDateValid" id="type">
                                                            <!-- settings is optional -->
                                                            <option v-for="(tType,index) in trainingTypeArr" :key="index" :value="tType.id">
                                                                {{tType.title}}
                                                            </option>
                                                        </selectize>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="">
                                                        <label style="font-weight:700;">Event Topic</label>
                                                        <input type="text" class="form-control form-control-sm" placeholder="Write Event Topic" v-model="trainingTopic" :disabled="isDateValid" id="training_topic" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label style="font-weight:700;" for="first">Location
                                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                    </label>
                                                    <selectize id="select-state location" v-model="district" :disabled="isDateValid">
                                                        <option v-for="(item,index) in cityArr" :key="index" :value="item.id">
                                                            {{item.title}}, {{item.province.title}},
                                                            {{item.province.country.title}}
                                                        </option>
                                                    </selectize>
                                                </div>
                                            </div>

                                            <div class="row mt-2">
                                                <div class="col-md-6">
                                                    <div class="">
                                                        <label style="font-weight:700;">Date Range
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                        </label>
                                                        <small class="text-info">
                                                            (Note: To choose one day, double click on
                                                            specific date)</small>
                                                        <flat-pickr class="form-control" style="background: #fff;opacity:1" placeholder="Start date Range" v-model="dateRange" :config="dateOptions" :disabled="isDateValid" id="date"></flat-pickr>
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <div class="">
                                                        <label style="font-weight:700;" for="first">Days</label>
                                                        <input class="floating-input form-control" v-model="noOfDays" type="text" disabled placeholder=" " />
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mt-2">
                                                <div class="col-md-6 col-lg-6" style="margin-top:10px;">
                                                    <div class="floating-label">
                                                        <input class="floating-input form-control" v-model="contact_number" type="text" v-mask="'(9999) 9999999'" placeholder=" " :disabled="isDateValid" id="contact" />
                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                            <i class="material-icons" style="font-size: 20px;">call</i>
                                                        </span>
                                                        <label class="lbl-label"> Contact Number </label>
                                                    </div>
                                                </div>

                                                <!-- email starts -->
                                                <div class="col-md-6" style="margin-top:10px;">
                                                    <div class="floating-label">
                                                        <input class="floating-input form-control" v-model="contact_email" type="email" placeholder=" " :disabled="isDateValid" id="email" />

                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                            <i class="material-icons" style="font-size: 20px;">email</i>
                                                        </span>
                                                        <label class="lbl-label"> Email </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-md-6">
                                                    <label style="font-weight:700;" for="first">Relevant Project Outcome<span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                                    <input type="text" class="form-control form-control-sm" v-model="outcome" id="outcome" />
                                                </div>
                                                <div class="col-md-6">
                                                    <label style="font-weight:700;" for="first">Relevant Project Output<span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                                    <input type="text" class="form-control form-control-sm" v-model="output" id="output" />
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <!-- floating input starts -->
                                                <div class="col-md-6" style="margin-top:10px;">
                                                    <div class="floating-label">
                                                        <input class="floating-input form-control" v-model="address" type="text" placeholder=" " autocomplete="off" :disabled="isDateValid" id="address" />

                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                            <i class="material-icons" style="font-size: 20px;">place</i>
                                                        </span>
                                                        <label class="lbl-label"> Address </label>
                                                    </div>
                                                </div>

                                                <div class="col-md-12 col-lg-12" style="margin-top:10px;">
                                                    <div class="floating-label">
                                                        <input class="floating-input form-control" v-model="venue" type="text" placeholder=" " autocomplete="off" :disabled="isDateValid" id="venue" />

                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                            <i class="material-icons" style="font-size: 20px;">account_balance</i>
                                                        </span>
                                                        <label class="lbl-label">
                                                            Venue
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Next Step Button Starts  -->
                                            <div class="row">
                                                <div class="col-md-12 text-right">
                                                    <router-link to="/dashboard/program-officer/todoList" class="btn btn-primary btn-sm m-1">Cancel</router-link>
                                                    <b-button class="btn btn-primary btn-sm" type="submit" variant="primary">Save & Next</b-button>
                                                </div>
                                            </div>

                                            <!-- Next Step Button Ends  -->
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Selectize from "vue2-selectize";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import {formatDateRange} from "../../../utils/DateFormate";
// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
    data: () => ({
        trainingTopic: "",
        outcome: "",
        output: "",
        inValid: [],
        updateTraining: [],
        donernameArr: [],
        departmentArr: [],
        dateRange: [],
        dateOptions: {
            wrap: true,
            weekNumbers: true,
            mode: "range",
            // maxDate: new Date().fp_incr(10),
            dateFormat: "d-m-Y"
        },
        // subprogramArr: [],
        isSidebar: false,
        isForm: true,
        isFormData: false,
        selected: "",
        subprogramSelected: "",
        project_title: "",

        subprogramsettings: {
            maxItems: 3,
            plugins: ["remove_button"],
            delimiter: "|"
        },
        departmentsettings: {
            maxItems: 10,
            plugins: ["remove_button"],
            delimiter: "|"
        },
        donerSelected: [],
        donersettings: {
            maxItems: 5,
            plugins: ["remove_button"],
            delimiter: "|"
        }, // https://github.com/selectize/selectize.js/blob/master/docs/usage.md

        contact_person: "",
        trainingId: "",
        trainingCode: "",
        contact_number: "",
        contact_email: "",
        address: "",
        options: {
            format: "DD/MM/YYYY",
            useCurrent: false
        },
        textarea: "",
        venue: "",
        counterDanger: false,
        mydate: "",
        startDate: "",
        agendasArray: [],
        agendasArraySecond: [],
        agendasArrayThird: [],
        newArr: [],
        newArrSecond: [],
        newArrThird: [],
        endDate: "",
        colorx: "#1db952",
        trainingCheck: false,
        repeatedCheck: false,
        selectedDoner: [],
        select1Normal: "",
        training_title: "",
        select2: 1,
        select3: 1,
        type_training: null,
        country: "",
        province: "",
        district: "",
        department: [],
        // project_title: 1,
        trainingtitleArr: [],
        projecttitleArr: [],

        trainingTypeArr: [],
        countryArr: [],
        provinceArr: [],
        cityArr: [],
        isDataEdit: 0,
        items: [],
        fields: [],
        training_status: "",
        trainingEndDate: "",
        isDateValid: false,
    }),
    watch: {
        dateRange(date) {
            this.startDate = date.split(" to")[0];
            this.endDate = date.split("to ")[1];
            this.isDataEdit++;
            if (this.isDataEdit > 1) {
                let daysLengthTotal;
                this.startDate = date.split(" to")[0];
                this.endDate = date.split("to ")[1];
                if (date.includes("to")) {
                    let daysInRange = document.getElementsByClassName("inRange");
                    if (this.startDate.split("-")[1] == this.endDate.split("-")[1]) {
                        daysLengthTotal = daysInRange.length + 2;
                    } else {
                        daysLengthTotal = daysInRange.length + 2;
                    }
                    this.noOfDays = daysLengthTotal;
                } else if (!date.includes("to") && date != "") {
                    this.startDate = date;
                    this.endDate = date;
                    this.noOfDays = 1;
                } else {
                    this.startDate = "";
                    this.endDate = "";
                    this.noOfDays = "";
                }
            }
        }
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.trainingCode = this.$route.query.trainingId;

        // Set the initial number of items
        this.totalRows = this.items.length;

        //select all district
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/districts/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.cityArr = response.data;
            });

        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/departments/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.departmentArr = response.data;
            });

        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/trainingtype/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingTypeArr = response.data;
            });

        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingTopic = response.data.training.trainingTopic || "";
                this.trainingId = response.data.training.id;
                this.training_status = response.data.training.trainingstatus;
                this.trainingEndDate = response.data.training.enddate;
                this.outcome = response.data.training?.outcome ?? '';
                this.output = response.data.training?.output ?? '';
                this.updateTraining = response.data?.training ?? [];
                

                this.selectedDoner = response.data.doner;
                response.data.doner.forEach(dnr => {
                    this.donerSelected.push(dnr.id);
                });
                if (response.data.training.typetraining_id != null) {
                    this.type_training = response.data.training.typetraining_id;
                }
                if (
                    response.data.training != undefined &&
                    response.data.training != null &&
                    response.data.training.noofdays
                ) {
                    this.noOfDays = response.data.training.noofdays;
                }
                if (
                    response.data.training.startdate != null &&
                    response.data.training.enddate != null
                ) {
                    this.dateRange =
                        response.data.training.startdate +
                        " to " +
                        response.data.training.enddate;
                }

                if (response.data.training.district_id != null) {
                    this.district = response.data.training.district_id;
                }
                if (response.data.training.contact_person != null) {
                    this.contact_person = response.data.training.contact_person;
                }
                if (response.data.training.contact_number != null) {
                    this.contact_number = response.data.training.contact_number;
                }
                if (response.data.training.email != null) {
                    this.contact_email = response.data.training.email;
                }
                if (response.data.training.address != null) {
                    this.address = response.data.training.address;
                }
                if (response.data.training.venue != null) {
                    this.venue = response.data.training.venue;
                }

                if (response.data.departments && response.data.departments != "") {
                    response.data.departments.forEach(department => {
                        this.department.push(department.id);
                    });
                }
                this.dateCheck();
                // this.type_training = response.data.trainingtype.title;
            });
    },
    components: {
        Selectize,
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        flatPickr
    },

    methods: {
        formatDateRange,
        // onclick show wizard steps
        trainerRegistration() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
            } else {
                this.$router.push({
                    path: '/dashboard/programOfficer/trainer-registration',
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            }
        },
        trainingAgenda() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
            } else {
                this.$router.push({
                    path: '/dashboard/programOfficer/training-agenda',
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            }
        },
        trainingMaterial() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
            } else {
                this.$router.push({
                    path: '/dashboard/programOfficer/wizardUploadMaterial',
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            }
        },
        trainingAssessment() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
            } else  {
                this.$router.push({
                    path: '/dashboard/programOfficer/training-assesment',
                    query: { trainingId: this.trainingCode }
                });
            } 
                
        },
        traineeReg() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
            } else {
                this.$router.push({
                    path: '/dashboard/programOfficer/trainee-registration',
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            }
        },
        assessmentReviewFunction() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
            } else {
                this.$router.push({
                    path: '/dashboard/programOfficer/assesment-review',
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            }
        },
        trainingCompletion() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
            } else {
                this.$router.push({
                    path: '/dashboard/programOfficer/wizard-completion',
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            }
        },

        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },

        showinputvalue: function (event) {
            this.name = event.target.value;
        },
        TrainingForm(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.startDate) {
                this.inValid.push("Start date is required.");
            }
            if (!this.endDate) {
                this.inValid.push("End date is required.");
            }
            if (!this.department || this.department.length < 1) {
                this.inValid.push("Department is required.");
            }
            if (!this.type_training) {
                this.inValid.push("Training Type is required.");
            }

            if (!this.district) {
                this.inValid.push("District is required.");
            }
            if (!this.venue) {
                this.inValid.push("Venue is required.");
            }
            if (!this.outcome) {
                this.inValid.push("Relevant Project Outcome is required.");
            }
            if (!this.output) {
                this.inValid.push("Relevant Project Output is required.");
            }
            //For phone number validation

            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {

                let self = this;
                // let noAccess = '';
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH + "/register/update/training", {
                            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                            trainingId: this.trainingId,
                            department: JSON.stringify(this.department),
                            type_training: this.type_training,
                            startDate: this.startDate,
                            endDate: this.endDate,
                            district: this.district,
                            contact_person: this.contact_person,
                            contact_number: this.contact_number,
                            contact_email: this.contact_email,
                            address: this.address,
                            venue: this.venue,
                            noOfDays: this.noOfDays,
                            trainingTopic: this.trainingTopic,
                            outcome: this.outcome,
                            output: this.output,
                        }, {
                            headers: {
                                Authorization: localStorage.getItem("token"),
                            }
                        }
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);

                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            self.resetForm();
                            //self.allTrainings();
                            this.$router.push({
                                name: "wizardTrainerRegistration",
                                query: {
                                    trainingId: this.trainingCode
                                }
                            });
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            this.department_name = "";
            this.type_training = null;
            this.contact_email = "";
            this.address = "";
            this.contact_person = "";
            this.contact_number = "";
            this.venue = "";
        },
        dateCheck() {
            const today = new Date();
            const dateString = this.trainingEndDate;
            const [day, month, year] = dateString.split("-");

            // Create a new date object for the target date
            const targetDate = new Date(`${year}-${month}-${day}`);

            // Add 7 days to the target date
            targetDate.setDate(targetDate.getDate() + 7);

            today.setHours(0, 0, 0, 0);
            targetDate.setHours(0, 0, 0, 0);

            // Compare today's date with the updated target date
            if (today > targetDate) {
                this.isDateValid = true;
            }

        },
    }
};
</script>

<style scoped>
.vs-breadcrumb {
    font-size: 18px !important;
    font-weight: 600 !important;
}

#progressbar .completed {
    color: #06a6e0;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
    background: #06a6e0;
}

#grad1 {
    background-color: #fff;
}

#msform {
    text-align: center;
    position: relative;
    margin-top: 20px;
}

#msform fieldset .form-card {
    background: white;
    border: 0 none;
    border-radius: 0px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    padding: 20px 40px 30px 40px;
    box-sizing: border-box;
    width: 94%;
    margin: 0 3% 20px 3%;
    position: relative;
}

#msform fieldset {
    padding: 10px;
    background: #e8e8e8;
    border: 0 none;
    border-radius: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}

#msform fieldset:not(:first-of-type) {
    display: none;
}

#msform fieldset .form-card {
    text-align: left;
    color: #9e9e9e;
}

#msform .action-button {
    width: 100px;
    background: skyblue;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
    width: 100px;
    background: #616161;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}

.card {
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
}

.fs-title {
    font-size: 25px;
    color: #2c3e50;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: left;
}

#progressbar {
    margin-bottom: 30px;
    overflow: hidden;
    color: lightgrey;
}

#progressbar .active {
    color: #000000;
}

#progressbar li {
    list-style-type: none;
    font-size: 12px;
    width: 9.5%;
    text-align: center;
    float: left;
    position: relative;
}

#progressbar #NewTraining:before {
    content: "1";
}

#progressbar #PoAssignment:before {
    content: "2";
}

#progressbar #TrainingInformation:before {
    content: "3";
}

#progressbar #TrainerRegistration:before {
    content: "4a";
}

#progressbar #TrainingAgenda:before {
    content: "4b";
}

#progressbar #Trainingmaterial:before {
    content: "4c";
}

#progressbar #TrainingAssessments:before {
    content: "4d";
}

#progressbar #TraineeRegistration:before {
    content: "4e";
}

#progressbar #AssessmentReview:before {
    content: "5";
}

#progressbar #Completion:before {
    content: "6";
}

#progressbar li:before {
    width: 35px;
    height: 35px;
    line-height: 30px;
    display: block;
    font-size: 18px;
    color: #ffffff;
    background: lightgray;
    border-radius: 50%;
    margin: 0 auto 10px auto;
    padding: 2px;
}

#progressbar li:after {
    content: "";
    width: 100%;
    height: 2px;
    background: lightgray;
    position: absolute;
    left: 0;
    top: 17px;
    z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
    background: #000000;
}

.radio-group {
    position: relative;
    margin-bottom: 25px;
}

.radio {
    display: inline-block;
    width: 204;
    height: 104;
    border-radius: 0;
    background: lightblue;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    cursor: pointer;
    margin: 8px 2px;
}

.radio:hover {
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
    width: 100%;
    object-fit: cover;
}
</style>
